module.exports = __webpack_public_path__ + "img/plant_1_mobile.1a8914af.webp";